import * as R from 'ramda'
import React from 'react'
import { Pagination, Select, Table } from 'semantic-ui-react'
import styled from 'styled-components'
import { getRaceBySlug, getRaceDetailByRace } from '../api/async/index'
import {
  getDistance,
  getMyRanking,
  getRanking
} from '../api/async/participants/index'
import { getGroupByRace } from '../api/sync/races'
import MedalRanking1 from '../assets/MedalRanking1.png'
import MedalRanking2 from '../assets/MedalRanking2.png'
import MedalRanking3 from '../assets/MedalRanking3.png'
import { Loader } from '../components/Loader'
import ProgressChart from '../components/ProgressChart'
import { isLogin } from '../utils/index'
import { getAvatar } from '../utils/profile'
import Login from './Login'
import Signup from './Signup'

const StyleSelect = styled(Select)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    width: 100%;
    margin-bottom: 10px;
  }
`

const StyledPagination = styled(Pagination)`
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    font-size: 0.6rem !important;
  }
`

const PAGESIZE = 50

class Ranking extends React.Component {
  state = {
    page: 1,
    loading: true,
    racesDetail: [],
    gender: 'all',
    showLogin: !isLogin(),
    showSignup: false,
    groups: []
  }

  async componentDidMount() {
    const slug = this.props.match.params.slug
    const raceRes = await getRaceBySlug(slug)
    this.setState({ race: raceRes.data })
    const res = await getRaceDetailByRace(this.state.race.id)
    this.setState({ racesDetail: res.data })
    this.setState({ selectedRaceDetail: res.data[0].id })

    getDistance(this.state.race.id).then(res => {
      if (res.status === 200)
        this.setState({ sumDistance: res.data.sum_distance })
    })

    isLogin() &&
      getMyRanking({ participant__race_detail: res.data[0].id }).then(res => {
        if (res.status === 200) {
          this.setState({ myRank: res.data.rank })
          this.setState({ myRun: res.data.run })
        }
      })

    getRanking({ participant__race_detail: res.data[0].id }).then(res => {
      this.setState({ stats: res.data.results })
      this.setState({ totalPages: Math.ceil(res.data.count / PAGESIZE) })
      this.setState({ loading: false })
    })
    const groups = await getGroupByRace(this.state.race.id)
    this.setState({ groups: groups.data })
  }

  handleChangePage = (e, { activePage }) => {
    this.setState({ loading: true })
    this.setState({ page: activePage })
    getRanking(this.getCurrentQuery(activePage)).then(res => {
      this.setState({ stats: res.data.results })
      this.setState({ loading: false })
    })
  }

  handleSelectChange = async (e, { name, value }) => {
    await this.setState({ [name]: value })
    this.setState({ page: 1 })
    this.setState({ loading: true })
    isLogin() &&
      getMyRanking(this.getCurrentQuery())
        .then(res => {
          this.setState({ myRank: res.data.rank })
          this.setState({ myRun: res.data.run })
        })
        .catch(e => {
          this.setState({ myRank: null })
          this.setState({ myRun: null })
        })
    getRanking(this.getCurrentQuery()).then(res => {
      this.setState({ stats: res.data.results })
      this.setState({ loading: false })
      this.setState({ totalPages: Math.ceil(res.data.count / PAGESIZE) })
    })
  }

  getCurrentQuery = page => ({
    participant__race_detail: this.state.selectedRaceDetail,
    page,
    ...(this.state.gender !== 'all' && {
      participant__gender: this.state.gender
    })
  })

  calCulateIndex = baseIndex => PAGESIZE * (this.state.page - 1) + baseIndex

  render() {
    const distanceOption = [...this.state.racesDetail.filter(each => !each.link_detail)].map((detail, _) => ({
      key: detail.id,
      text: detail.distance.name,
      value: detail.id
    }))

    return this.state.loading ? (
      <Loader />
    ) : (
      <React.Fragment>
        <h2>{R.path(['race', 'title'], this.state.racesDetail[0])}</h2>
        {this.state.sumDistance && (
          <h3>
            ยอดวิ่งสะสมรวม :: {this.state.sumDistance.toLocaleString()} KM
          </h3>
        )}
        {this.state.groups.length ? <ProgressChart race={R.path(['race', 'id'], this.state.racesDetail[0])}/> : null}
        <p> (ผลการจัดอันดับจะโชว์เมื่อนักวิ่ง วิ่งครบระยะแล้วเท่านั้น)</p>
        <StyleSelect
          name="gender"
          value={this.state.gender}
          onChange={this.handleSelectChange}
          placeholder="เพศ"
          options={[
            { key: 'm', text: 'ชาย', value: 'male' },
            { key: 'f', text: 'หญิง', value: 'female' },
            { key: 'f', text: 'ทั้งหมด', value: 'all' }
          ]}
          style={{ marginRight: 10 }}
        />
        <StyleSelect
          name="selectedRaceDetail"
          value={this.state.selectedRaceDetail}
          onChange={this.handleSelectChange}
          placeholder="ระยะทาง"
          options={distanceOption}
        />
        <Table unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={1}>Rank</Table.HeaderCell>
              <Table.HeaderCell>Runner</Table.HeaderCell>
              <Table.HeaderCell textAlign="right">Result</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.stats.map((each, index) => (
              <React.Fragment>
                <Table.Row key={this.calCulateIndex(index)}>
                  <Table.Cell width={1} textAlign="center">
                    {this.calCulateIndex(index) + 1 === 1 ? (
                      <img src={MedalRanking1} />
                    ) : this.calCulateIndex(index) + 1 === 2 ? (
                      <img src={MedalRanking2} />
                    ) : this.calCulateIndex(index) + 1 === 3 ? (
                      <img src={MedalRanking3} />
                    ) : (
                      this.calCulateIndex(index) + 1
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    <img
                      style={{ width: 50 }}
                      className="ui middle aligned spaced image circular mobile-not-show"
                      src={getAvatar(each.participant.runner)}
                    />
                    <span>{each.participant.name}</span>
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    <p>{each.distance.toFixed(2)}KM</p>
                  </Table.Cell>
                </Table.Row>
                {this.calCulateIndex(index) + 1 === 3 && this.state.myRank > 3 && (
                  <Table.Row
                    key={this.calCulateIndex(index)}
                    style={{ backgroundColor: 'rgb(255, 230, 135)' }}
                  >
                    <Table.Cell width={1} textAlign="center">
                      {this.state.myRank}
                    </Table.Cell>
                    <Table.Cell>
                      <img
                        style={{ width: 50 }}
                        className="ui middle aligned spaced image circular mobile-not-show"
                        src={getAvatar(this.state.myRun.participant.runner)}
                      />
                      <span>{this.state.myRun.participant.name}</span>
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <p>{this.state.myRun.distance.toFixed(2)}KM</p>
                    </Table.Cell>
                  </Table.Row>
                )}
              </React.Fragment>
            ))}
          </Table.Body>
        </Table>
        <StyledPagination
          defaultActivePage={this.state.page}
          totalPages={this.state.totalPages || 1}
          onPageChange={this.handleChangePage}
        />
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          next={this.props.history.location.pathname}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          next={this.props.history.location.pathname}
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default Ranking



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Ranking.js